import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRpmUserNotesToPatientList } from "../../../../../Redux/actions/rpmActions";
import moment from "moment";
import rpmService from "../../../../../Services/rpmService";
import Sendicon from "../../../../../Assets/Images/Svg/sendicon.svg";
import { convertUTCDate } from "../../../../../utils/convertionFunc";
import { message } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Layouts from "../../../../Layouts";

function AddClinicalNote({ setIsNotesUpdated, isBackButtonPresent = true }) {
  const [newMessage, setNewMessage] = useState("");
  const { selectedRpmPatient, userNotesToPatient } = useSelector(
    (state) => state.rpm
  );
  const messageListRef = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    const payload = {
      patientCode: selectedRpmPatient.patientId,
      status: 1,
    };
    dispatch(fetchRpmUserNotesToPatientList(payload));
  }, []);

  const handleSendMessage = async () => {
    if (!newMessage.trim()) {
      return;
    }
    const payload = {
      date: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      notes: newMessage,
      patientCode: selectedRpmPatient.patientId,
      userCode: selectedRpmPatient.createdBy,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      createdBy: loggedUser?.user?.userId,
      modifiedBy: loggedUser?.user?.userId,
      status: 1,
    };

    try {
      await rpmService.addNewNoteToPatient(payload);
      const UserNotesPayload = {
        patientCode: selectedRpmPatient.patientId,
        status: 1,
      };
      setNewMessage("");
      dispatch(fetchRpmUserNotesToPatientList(UserNotesPayload));
      setIsNotesUpdated(true);
    } catch (e) {
      console.error(e);
    }
  };

  const handleNavigation = () => {
    history.go(-1);
  };

  return (
    <Layouts>
      <div>
        <>
          <div className="mt-5 grid grid-cols ">
            {isBackButtonPresent && (
              <div className="flex items-center justify-end px-5">
                <button
                  className="w-20 p-2 rounded-md bg-brand-primaryColor text-white"
                  onClick={handleNavigation}
                >
                  Back
                </button>
              </div>
            )}
            <div className={`bg-white rounded-lg p-5`}>
              <div className="h-full shadow-lg margin-zauto bg-white border rounded-2xl">
                <div className="flex justify-between items-center border-b p-3 px-5">
                  <div className="flex items-center">
                    {selectedRpmPatient.photoName ? (
                      <div className="relative w-12 h-12 border rounded-full">
                        <img
                          className="rounded-full w-full h-full object-contain"
                          src={
                            process.env.REACT_APP_IMAGE_URL +
                            selectedRpmPatient?.photoName
                          }
                          alt={selectedRpmPatient.firstName}
                        />
                      </div>
                    ) : (
                      <div
                        className="md:w-24 md:h-24 h-20 rounded-full text-5xl text-white font-semibold flex justify-center items-center"
                        style={{
                          backgroundColor: ["#003484"],
                        }}
                      >
                        {selectedRpmPatient.firstName +
                          "" +
                          selectedRpmPatient.lastName}
                      </div>
                    )}

                    <div className="ml-3">
                      <div className="text-brand-textBold capitalize text-xl font-bold  pb-1">
                        {selectedRpmPatient.salutation}.{" "}
                        {selectedRpmPatient.firstName}{" "}
                        {selectedRpmPatient.lastName}
                      </div>
                      <div className="text-brand-textGray text-xs font-normal">
                        {/* {select.code} */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="chat-container">
                  <div
                    className="message-list bg-[#f4f4f4]  overflow-y-auto overflow-x-hidden p-3"
                    ref={messageListRef}
                  >
                    {userNotesToPatient.map((message, index) =>
                      message.createdBy === loggedUser.user.userId ? (
                        <div
                          className="message flex items-end flex-col"
                          key={index}
                        >
                          <div className=" w-2/4 mb-3">
                            <div className="flex items-end">
                              <div className="message-text2 bg-[#cdfff3] text-textGray text-base relative w-full rounded-lg px-4 py-2 text-baseline">
                                <div className="message-timestamp text-textBold text-xs font-bold mb-3">
                                  You
                                </div>
                                {message.notes}
                              </div>
                            </div>
                            <div className="message-timestamp text-right mt-2 text-brand-textGray text-xs mr-12">
                              {moment(message.createdDate).format("LT - L")}
                            </div>
                          </div>
                        </div>
                      ) : message.createdBy !== loggedUser.user.userId ? (
                        <div className="message-list  " ref={messageListRef}>
                          <div className="message w-2/4 p-3" key={index}>
                            <div className="flex items-end">
                              <div className="message-text bg-white text-textGray text-base relative w-full rounded-lg px-4 py-2 text-baseline">
                                <div className="message-timestamp text-textBold text-xs font-bold mb-3">
                                  {message.createdName}
                                </div>
                                {message.notes}
                              </div>
                            </div>
                            <div className="message-timestamp text-right mt-2 text-brand-textGray text-xs">
                              {moment(message.createdDate).format("LT - L")}
                            </div>
                          </div>
                        </div>
                      ) : null
                    )}
                  </div>
                </div>
                <div className="message-input flex border-t items-center px-5 py-1">
                  <input
                    type="text"
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    placeholder="Type your message..."
                    className="w-full h-14 bg-transparent p-3 outline-0 rounded"
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault(); // Prevent the default Enter key behavior (e.g., adding a new line)
                        handleSendMessage(); // Call your function to send the message
                      }
                    }}
                  />
                  <div
                    className="bg-brand-primaryColor hover:bg-[#003484] text-brand-textWhite font-bold w-12 h-12 flex items-center justify-center cursor-pointer rounded-full"
                    onClick={handleSendMessage}
                  >
                    <img src={Sendicon} alt="img" width={25} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </div>
    </Layouts>
  );
}

export default AddClinicalNote;
